export function getTwitchChannel(webcamUrl) {
  if (!webcamUrl) return null
  const match = webcamUrl.match(/^(https?:\/\/)?(\w+\.)?twitch\.tv\/(\w+)\/?/)
  return match ? match[3] : null
}
